import { Alert, List } from '@ksyos/design-system';
import type { IOrganizationGetOne } from '@frontend/components/interfaces';
import { getSelectedLanguage } from '@frontend/translate';

type DuplicateOrganizationsAlertProps = {
    duplicateOrganizations: IOrganizationGetOne[];
};

export function DuplicateOrganizationsAlert({ duplicateOrganizations }: DuplicateOrganizationsAlertProps) {
    const translate = getSelectedLanguage();

    if (duplicateOrganizations.length === 0) {
        return null;
    }

    return (
        <Alert appearance="info">
            <Alert.Text mb={2}>{`${translate.organization.existingOrganizations} `}</Alert.Text>
            <List styleType="bullet">
                {duplicateOrganizations.map((duplicateOrganization) => (
                    <List.Item key={duplicateOrganization.id}>
                        <Alert.Link
                            key={duplicateOrganization.id}
                            openInNewTab={true}
                            to={`/organizations/${duplicateOrganization.id}/view/details`}
                            variant="link"
                        >
                            {duplicateOrganization.name} ({duplicateOrganization.txcsId})
                        </Alert.Link>
                    </List.Item>
                ))}
            </List>
        </Alert>
    );
}
